import http from '../utils/http';
import axios from 'axios';
import i18n from '@/main';

const baseUrl = '/contrato-rastreabilidade/v1';

export default {
    findAll(params) {
        return http.get({
            url:
                baseUrl +
                `?page=${params.page || 0}&size=${params.size || 10
                }&status=${params.status.join(',')}&contractNumber=${params.contract_number
                }&client=${params.client}&harvestYear=${params.safra
                }&cultures=${params.cultivations.join(',')}&perfil=${params.perfil
                }&sort=createdAt desc`,
            lockScreen: true
        });
    },
    create(formData) {
        const url = process.env.VUE_APP_HTTP_PATH + baseUrl;
        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    persistDetailFiles(formData) {
        const url = `${process.env.VUE_APP_HTTP_PATH + baseUrl}/files`;
        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    findAllDetailFiles(detailId) {
        const url = `${process.env.VUE_APP_HTTP_PATH + baseUrl}/files/${detailId}`;
        return axios.post(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    deleteAllDetailFiles(detailId) {
        const url = `${process.env.VUE_APP_HTTP_PATH + baseUrl}/files/${detailId}`;
        return axios.delete(url, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    },
    getEligibility(id, document, contractDistrict) {
        return http.post({
            url: `${baseUrl}/elegibility`,
            data: {
                document: document,
                idTerritorio: String(id),
                protocol: 'PROTOCOLO_PARAGUAI',
                contractDistrict: contractDistrict
            },
            lockScreen: true
        });
    },
    getAvailableBalance(id, extraArea = '', harvestYear) {
        let path = `/available-balance/${id}?harvestYear=${harvestYear}`;
        if (extraArea) {
            path = `${path}&extraArea=${extraArea}`;
        }
        return http.get({
            url: `${baseUrl}${path}`,
            lockScreen: true
        });
    },
    validateAvailableBalance(id, extraArea = '', harvestYear) {
        let path = `/available-balance/${id}?harvestYear=${harvestYear}`;
        if (extraArea) {
            path = `${path}&extraArea=${extraArea}`;
        }
        return http.get({
            url: `${baseUrl}${path}`,
            lockScreen: true
        });
    },
    getSummary(perfil) {
        return http.get({
            url: `${baseUrl}/totalizers?perfil=${perfil}`,
            lockScreen: false
        });
    },
    detail(id) {
        return http.get({
            url: `${baseUrl}/${id}`,
            lockScreen: true
        });
    },
    deleteReport(id) {
        return http.delete({
            url: `${baseUrl}/${id}`,
            lockScreen: true
        });
    },
    downloadInvoice(reportId, invoiceId) {
        return http.get({
            url: `${baseUrl}/${reportId}/download-blob/${invoiceId}`,
            responseType: 'blob',
            lockScreen: true
        });
    },
    downloadInvoices(detailId) {
        return http.get({
            url: `${baseUrl}/download-blobs/${detailId}`,
            responseType: 'blob',
            lockScreen: true
        });
    },
    downloadReport(id) {
        return http.get({
            url: `${baseUrl}/pdf/${id}`,
            responseType: 'blob',
            lockScreen: true
        });
    },
    reportApprove(id) {
        return http.patch({
            url: `${baseUrl}/approve/${id}`,
            lockScreen: true
        });
    },
    reportReprove(reportId, reason, justification) {
        return http.patch({
            url: `${baseUrl}/repprove`,
            data: {
                idReport: reportId,
                reason: reason,
                justificate: justification
            },
            lockScreen: true
        });
    },
    findByTerritory(idTerritory) {
        return http.get({
            url: `${baseUrl}/territorios/${idTerritory}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoContratos')
        });
    }
};
